import script from "./huangjiangyangdujun.vue?vue&type=script&setup=true&lang=js"
export * from "./huangjiangyangdujun.vue?vue&type=script&setup=true&lang=js"

import "./huangjiangyangdujun.vue?vue&type=style&index=0&id=cec29a6a&lang=less&scoped=true"
script.__scopeId = "data-v-cec29a6a"

export default script